// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__3vGBH","Label":"BuildControl_Label__3i4A7","Less":"BuildControl_Less__3xLWb","More":"BuildControl_More__3NBKx"};